import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Lightbox } from "react-modal-image";
import React, { useState } from 'react';


const Docm = ({ list, building, deleteDocument }) => {
  const [open, setOpen] = useState(false)


  const [img, setImg] = useState()
  const pdflogo = "https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExOWNiYTNkNjNiMmM4ZTEyYmY4ZTg4NmM3NTQ1NjM1MTJmOTc2N2RiZCZjdD1n/yzdoolKTs3yYG4NYNu/giphy.gif"
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const closeLightbox = () => {
    setOpen(!open);
  };


  const selectedImg = (imgUrl) => {
    setImg(imgUrl)
    setOpen(!open)
  }

  return (
    <>
      {list && <Carousel
        swipeable={false}
        draggable={false}
        responsive={responsive}
        infinite={false}
        autoPlaySpeed={1500}
        keyBoardControl={true}
        customTransition="all .4s ease-in-out"
        transitionDuration={500}
        containerClassName="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
      >
        {
          list?.map((item, i) => {
            return (
              <div className="card bg-none border  mx-3 h-100 reponsive-card" key={i}>
                <div className="h-100 d-flex justify-content-center align-items-center">
                  <img onClick={() => selectedImg(item.documenturl)} src={(`${item?.documenturl.includes(".pdf") || item?.documenturl.includes(".docx") || item?.documenturl.includes(".doc") ? pdflogo : item?.documenturl}`)} alt={item.documentname} className="img-fit" />

                </div>
                {building == true ? <label htmlFor='image' className="bg-base-color text-white d-flex justify-content-center align-items-center py-2 base-box-shadow"> <span className="fs-4 title-font-400 ">{item.documentname}</span>  <i className="fa-solid fa-trash-can status-color-red fs-3 ms-3 pointer" onClick={() => { deleteDocument(item) }}></i></label>
                  :
                  <label htmlFor='images' className="bg-base-color text-white text-center base-font-600 fs-4 title-font-400 pt-2 base-box-shadow">{item.documentname}</label>
                }
              </div>
            )
          }
          )

        }
      </Carousel>}
      {
        open && (
          <Lightbox
            medium={img}
            large={img}
            onClose={closeLightbox}
          />
        )
      }
    </>
  )
}

export default Docm

